import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MatIconModule } from '@angular/material/icon';
import { MatRippleModule } from '@angular/material/core';

interface SectorOption {
  id: string;
  label: string;
  icon: string;
}

@Component({
  selector: 'app-sector-picker-sheet',
  imports: [MatIconModule, MatRippleModule],
  template: `
    <div class="sector-picker">
      <h3 class="sector-picker__title">Seleziona un settore</h3>
      <div class="sector-picker__grid">
        @for (sector of sectors; track sector.id) {
          <button
            class="sector-picker__fab"
            (click)="selectSector(sector.id)"
            [attr.aria-label]="sector.label"
            matRipple
          >
            <span class="sector-picker__icon-wrap">
              <mat-icon class="sector-picker__icon">{{ sector.icon }}</mat-icon>
              <span class="sector-picker__letter">{{ sector.id }}</span>
            </span>
          </button>
        }
      </div>
    </div>
  `,
  styles: [
    `
      .sector-picker {
        padding: 8px 16px calc(8px + env(safe-area-inset-bottom));
      }
      .sector-picker__title {
        margin: 0 0 16px;
        font-size: 0.75rem;
        font-weight: 600;
        letter-spacing: 0.08em;
        text-transform: uppercase;
        text-align: center;
        color: var(--mat-sys-on-surface-variant);
      }
      .sector-picker__grid {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 16px 12px;
        justify-items: center;
      }
      .sector-picker__fab {
        width: 72px;
        height: 72px;
        border-radius: 20px;
        border: none;
        background-color: var(--mat-sys-secondary-container);
        cursor: pointer;
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: background-color 200ms ease;
        -webkit-tap-highlight-color: transparent;
        position: relative;
      }
      .sector-picker__fab:hover {
        background-color: color-mix(
          in srgb,
          var(--mat-sys-on-secondary-container) 12%,
          var(--mat-sys-secondary-container)
        );
      }
      .sector-picker__icon-wrap {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
      }
      .sector-picker__icon {
        font-size: 48px;
        width: 48px;
        height: 48px;
        opacity: 0.35;
      }
      .sector-picker__letter {
        position: absolute;
        font-size: 2.25rem;
        font-weight: 700;
        font-style: italic;
        color: var(--mat-sys-on-secondary-container);
        line-height: 1;
      }
    `,
  ],
})
export class SectorPickerSheetComponent {
  private readonly router = inject(Router);
  private readonly sheetRef = inject(MatBottomSheetRef<SectorPickerSheetComponent>);

  protected readonly sectors: SectorOption[] = [
    { id: 'A', label: 'Settore A', icon: 'handshake' },
    { id: 'B', label: 'Settore B', icon: 'fitness_center' },
    { id: 'C', label: 'Settore C', icon: 'healing' },
    { id: 'D', label: 'Settore D', icon: 'monitor_heart' },
    { id: 'E', label: 'Settore E', icon: 'sports_martial_arts' },
  ];

  protected selectSector(id: string): void {
    this.sheetRef.dismiss();
    this.router.navigate(['/sector', id]);
  }
}
